<!--
 * @Descripttion: 
 * @version: v1
 * @Author: Terry
 * @Date: 2020-06-04 17:18:56
 * @LastEditors: Terry
 * @LastEditTime: 2023-02-27 15:14:07
-->
<template>
    <div class="flex login" >
      <div class="flex login-container">
        <div class="login-header text">
          <div class="w-100 t-c">
            <h2>智慧建筑管理后台</h2>
          </div>
          <div class="t-c m-t-10">
              国内领先的建筑业劳务管理系统
          </div>
            <el-card>
              <el-tabs v-model="type" @tab-click="changeType">
                <el-tab-pane label="账号登陆" name="loginForm">
                  <span >
                    <el-form :model="loginForm" :rules="rules" ref="loginForm" class="m-t-35" >
                        <el-form-item prop="account">
                          <el-input
                            v-model="loginForm.account"
                            placeholder="请输入帐号/手机号码"
                          ></el-input>
                        </el-form-item>
                        <el-form-item prop="password">
                          <el-input
                            type="password"
                            v-model="loginForm.password"
                            autocomplete="off"
                            placeholder="请输入密码"
                          ></el-input>
                        </el-form-item>
                        <el-form-item >
                          <el-button
                            type="primary"
                            class="button"
                            @click="login"
                            >登陆</el-button
                          >
                        </el-form-item>
                      </el-form>
                    </span>
                </el-tab-pane>
                <el-tab-pane label="扫码登录" name="qrCode">
                <div  class="flex qr-body" >
                    <div class="flex qrCode" v-loading='qrLoad'>
                          <div class="qr-remark w-75"
                          v-if="qrMask"
                          >
                            <div class="t-c" >
                                  <p class="text-black">二维码已失效</p>
                              <el-button type="primary" v-on:click="reloadQrCode">刷新</el-button>                    
                            </div>
                          </div>
                          <img  :src="qrCode" alt=""  style="min-width:260px;min-height:260px">
                    </div> 
                      <p  class="t-c text m-t-10">微信扫描二维码即可登陆</p>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </el-card>
        </div>
      </div>
      <div>
  </div>
    <div  class='text footer'>
      <strong>
        <span class="text-gray">
          ©版权所有
        </span>
        <a href="https://beian.miit.gov.cn/" class="text" target="_blank">粤ICP备2020130674号-1</a>
      </strong> 
    </div>
  </div>
</template>

<style lang="scss" scoped>
  ::v-deep .el-tabs__item{
    color: white;
    &:hover{
      color: #409EFF;
    }
  }
  ::v-deep .is-active{
    color: #409EFF;
  }
  ::v-deep .el-tabs__nav-scroll{
    width:50%;
    margin:0 auto
  }

  .footer{
    position: absolute;
    bottom: 10px;
  }
  a{
    text-decoration:none;
  }
  .text{
    color: #d9e6f3;
    text-shadow:#000000 3px 2px 1px
  } 
  .flex{
    display: flex;  
  }
  .login{
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    flex-direction:column;
  }
  .login-container{
    padding: 20px;
    justify-content: center;
    width: 350px;
    background: rgba(73, 72, 72, 0.3);
    box-shadow: 0 0 0 1px hsla(0,0%,100%,.3) inset, 0 .5em 1em rgba(0, 0, 0, 0.6);
    border-radius: 20px;
      .login-header{
        width: 100%;
        .logo{
          align-items: center;
          justify-content: center;
          
        }
      }
  }
  .button{
    width: 100%;
  }
  .el-card{
    border: none;
    background: none;
    box-shadow: none;
    padding: 0;
  }
  .qr-body{
    flex-direction: column;
  }
  .qrCode{
    margin:  0 auto;
    text-align: center;
  }
  .qr-remark{
      position:absolute;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 280px;
      width: 280px;
      background:#ffffffe6;
      z-index:999;
      text-shadow:none; 
  }
  .h-90-vh{
    height: 90vh;
  }
</style> 
<script>
export default {
  data() {
    return {
      qrLoad:true,
      type:'qrCode',
      loginForm: {
        account: "",
        password: ""
      },
      rules: {
        account: [
          { required: true, message: "账号不能为空", trigger: "blur" }
        ],
        password: [
          { required: true, message: "密码不能为空", trigger: "blur" },
          { min: 6, max: 16, message: "密码长度在6-16位", trigger: "blur" }
        ]
      },
      qrCode:'',
      qrKey:'',
      qrMask:false,
      interval:'',
    };
  },
  methods: {
    /**
     * @Descripttion: 获取登陆二维码
     * @name: getQrCode
     * @Author: Terry
     * @Date: 2020-09-11 17:22:24
     * @param {type}
     */
    getQrCode() {
      this.axios.get(this.api.auth.getQrCode).then(res => {
        if(res.code==0){
          this.qrMask  = false;
          this.qrCode  = res.data.qrCode;
          this.qrKey  = res.data.qrKey;
          this.checkLogin();
        }else{
           this.qrMask  = true;
        }
      }).finally(()=>{
        this.qrLoad =  false;
      })
    },
    reloadQrCode(){
      this.qrLoad =  true;
      this.qrMask  = false;
      this.qrCode  = '';
      this.getQrCode();
    },
    /**
     * @Descripttion: 轮询检查登陆状态
     * @name: 
     * @Author: Terry
     * @Date: 2020-09-13 22:02:46
     * @param {type} 
     */
    checkLogin(){
      var count = 0;
      var interval = setInterval(() => {
        if(this.type !='qrCode') clearInterval(interval);
        this.axios.get(this.api.auth.checkLogin,{'params':{'qrKey':this.qrKey}}).then(res=>{
          if(res.code == 0){
            sessionStorage.setItem("auxfaceToken", res.data.token);//token
            sessionStorage.setItem("uuid", res.data.uuid);//用户uuid
            sessionStorage.setItem("myCorpCode", res.data.corpCode);//用户公司认证的uuid
            sessionStorage.setItem("avatarUrl", res.data.info.avatarUrl); //头像
            sessionStorage.setItem("nickName", res.data.info.nickName); //名称
            this.$router.push({ name: "prjList" });
            clearInterval(interval);
          }
          if(count>=29){
            this.qrMask  = true;
            clearInterval(interval);
          } 
        }).catch(()=>{
            if(count>=29){
            this.qrMask  = true;
            clearInterval(interval);
          } 
        })
        count++;
      }, 1000);
    },
    changeType(){
      // this.type = type;
      if(this.type=='qrCode') this.getQrCode();
    },
    login(){
       // 表单判断
        this.$refs.loginForm.validate((valid) => {
            if (valid) {
                var load = this.loading();
                this.axios.post(this.api.auth.pcLogin,this.loginForm).then(res=>{
                      sessionStorage.setItem("auxfaceToken", res.data.token);//token
                      sessionStorage.setItem("uuid", res.data.uuid);//用户uuid
                      sessionStorage.setItem("nickName", res.data.info.nickName); //名称
                      sessionStorage.setItem("avatarUrl", res.data.info.avatarUrl); //头像
                      this.$router.push({ name: "pHome" });
                }).finally(()=>{
                    load.close();
                })
            }
        }); 
    }
  },
  mounted() {
    this.getQrCode();
  },created(){
      var that = this;
      document.onkeydown = function(e){
        if(e.key =='Enter'){
          that.login();
        }
      }
  }
};
</script>
